import { useMutation } from '@tanstack/react-query';
import { updateHabitOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateHabitOrderMutation = () =>
  useMutation({
    mutationFn: async (newOrder: ID[]) => updateHabitOrder(newOrder),
  });
